import moment from 'moment';

/**
 * A card or media start time (`starts_at`, RFC3339) as the card date label, in the viewer's zone:
 * "Oct 4, 2026 · 7:00 PM EDT", or the date alone when the value has no time. A bare `YYYY-MM-DD`
 * (an event's `event_day`, its own date at the venue) is a calendar day, not UTC midnight: shown
 * as is, with no zone.
 */
export const formatChannelEventDate = rawDate => {
  if (!rawDate) {
    return '';
  }

  const raw = String(rawDate);
  if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) {
    const day = moment(raw, 'YYYY-MM-DD', true);
    return day.isValid() ? day.format('MMM D, YYYY') : '';
  }
  const parsedUtc = moment.utc(raw);
  const parsedLocal = parsedUtc.isValid() ? parsedUtc.local() : moment(raw);
  if (!parsedLocal.isValid()) {
    return '';
  }

  const hasTime = /T\d{1,2}:\d{2}| \d{1,2}:\d{2}/.test(raw);
  const base = parsedLocal.format(hasTime ? 'MMM D, YYYY · h:mm A' : 'MMM D, YYYY');

  let tzAbbr = '';
  try {
    tzAbbr =
      new Intl.DateTimeFormat('en-US', { timeZoneName: 'short' })
        .formatToParts(parsedLocal.toDate())
        .find(part => part.type === 'timeZoneName')?.value || '';
  } catch {
    // Ignore timezone abbreviation failures; date/time formatting still works.
  }

  return `${base}${tzAbbr ? ` ${tzAbbr}` : ''}`;
};
